import { createTheme } from '@mui/material/styles';
import { amber, cyan, green, red } from '@mui/material/colors';

const insinetBrandColor = '#e5c496';
const insinetSecondaryColor = '#cacacf';

export const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    mode: 'dark',
    primary: { main: insinetBrandColor },
    secondary: { main: insinetSecondaryColor },
    danger: {
      light: red[300],
      main: red[500],
      dark: red[700],
    },
    success: {
      light: green[300],
      main: green[500],
      dark: green[700],
    },
    warning: {
      light: amber[300],
      main: amber[500],
      dark: amber[700],
    },
    info: {
      light: cyan[300],
      main: cyan[500],
      dark: cyan[700],
    },
  },
  components: {
    MuiIcon: {
      defaultProps: {
        fontSize: 'small',
      },
    },
    MuiGrid: {
      defaultProps: {
        spacing: 2,
      },
    },
  },
  mixins: {
    ellipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    popperResponsive: {
      zIndex: 1640,
      position: 'static',
      float: 'none',
      width: 'auto',
      marginTop: 0,
      backgroundColor: 'transparent',
      border: 0,
      boxShadow: 'none',
      color: 'black',
    },
    dropdown: {
      borderRadius: '3px',
      border: 0,
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
      top: '100%',
      zIndex: 1000,
      minWidth: '160px',
      padding: '5px 0',
      margin: '2px 0 0',
      fontSize: '14px',
      textAlign: 'left',
      listStyle: 'none',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
    },
    dropdownItem: {
      fontSize: '13px',
      padding: '10px 20px',
      margin: '0 5px',
      borderRadius: '2px',
      transition: 'all 150ms linear',
      display: 'block',
      clear: 'both',
      fontWeight: 400,
      minHeight: 40,
      lineHeight: '1.42857143',
      color: '#333',
      whiteSpace: 'nowrap',
      height: 'unset',
      '&.Mui-selected': {
        backgroundColor: insinetBrandColor,
      },
      '&:hover': {
        backgroundColor: insinetBrandColor,
        color: '#FFFFFF',
        boxShadow: '0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)',
      },
    },
  },

  drawerWidth: 260,
  loadingDelay: '200ms',
});

// Extending the MUI Theme and ThemeOptions interfaces to add custom properties
declare module '@mui/material' {
  interface Theme {
    drawerWidth: number;
    loadingDelay: string;
  }

  interface ThemeOptions {
    drawerWidth?: number;
    loadingDelay?: string;
  }
}

// Extending the Palette interface
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    danger: PaletteColor;
    success: PaletteColor;
    warning: PaletteColor;
    info: PaletteColor;
  }

  interface PaletteOptions {
    danger?: PaletteColorOptions;
    success?: PaletteColorOptions;
    warning?: PaletteColorOptions;
    info?: PaletteColorOptions;
  }
}

// Extending the Mixins interface for custom styles
declare module '@mui/material/styles/createMixins' {
  interface Mixins {
    ellipsis: CSSProperties;
    popperResponsive: CSSProperties;
    dropdown: CSSProperties;
    dropdownItem: CSSProperties;
  }
}
